import { Vector3 } from "three";
import { DataType } from "../../../../evaluators/DataType";
import { EvaluationResult } from "../../../../evaluators/EvaluationResult";
import { Evaluator } from "../../../../evaluators/Evaluator";
import { BinaryExpression } from "../../../../expressions/BinaryExpression";

export abstract class BinaryFunction
{
  left:EvaluationResult<any>;
  right:EvaluationResult<any>;

  evaluator:Evaluator;
  binaryExpression:BinaryExpression;

  get leftNumber() { return this.left.data as number; }
  get rightNumber() { return this.right.data as number; }

  get leftVector3() { return this.left.data as Vector3; }
  get rightVector3() { return this.right.data as Vector3; }

  process( e:Evaluator, b:BinaryExpression, values:[EvaluationResult<any>,EvaluationResult<any>] )
  {
    this.evaluator = e;
    this.binaryExpression = b;
    this.left = values[ 0 ];
    this.right = values[ 1 ];

    return this._process();
  }

  abstract _process():EvaluationResult<any>;

  typesAre( left:DataType, right:DataType = undefined )
  {
    right = right || left;
    return left === this.left.type && right === this.right.type;
  }

  typesAreAny( left:DataType, right:DataType = undefined )
  {
    return this.typesAre( left, right ) || this.typesAre( right, left );
  }
}